import styled from "styled-components";

export const DateRangePickerWrapper = styled.div`
position: relative;

 .dropdown, .date-picker {
    padding: 12px 8px;
    color: #000;
    cursor: pointer;
    min-width: 207px;
    border-radius: 5px;
    background-color: #F4F8F8;
    font-size: 12px;
    height: 40px;
    border: 1px solid transparent;
    font-family: Poppins, sans-serif;
    white-space: nowrap;
    span{
      color: #333;
      font-family: Poppins, sans-serif;
      
    }
   
  }
  .date-range-container {
    position: absolute;
    background: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 5px;
    z-index: 10;
    width: 100vw;
    right: 0;
    max-width: 300px;
    top: calc(100% + 10px);

    .rdrDayToday .rdrDayNumber span {

}

.rdrDaySelected, .rdrDayHovered, .rdrDayStartPreview, .rdrDayEndPreview, .rdrDayInPreview {
 
}

.rdrDayDisabled{
  background-color: transparent!important;
   .rdrInRange{
    background-color: transparent;
    & ~ .rdrDayNumber{
    span{
      color:#aeb9bf !important;
    }
  }
}
    
    .rdrDateRangeWrapper{
      width: 100%;
      .rdrMonth{
      width: 100%;
    }
    }
    
  }
    
    .rdrDateRangeWrapper{
      width: 100%;
      .rdrMonth{
      width: 100%;
    }
    }
    
  }
.button{
  padding: 10px 8px;
  .apply-button {
    width: 100%;
    background: #00BAF2;
    color: white;
    padding: 8px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 5px;
  }
}
.no-highlight .rdrInRange,
.no-highlight .rdrStartEdge,
.no-highlight .rdrEndEdge {
  background: none !important;
  box-shadow: none !important;
}
@media (max-width: 767px) {
    .date-picker{
    width: 100%;
  }
}
`;